export class Tracking {
	constructor() {
		let _this = this;

		$(document).on('click', '[data-tracking]', function (e) {
			_this.click($(this), e);
		})
	}

	click(el, event) {
		let title = el.data('tracking-title');
		let queue = el.data('tracking-queue');
		let sponsor = el.data('tracking-sponsor');
		let year = el.data('tracking-year');
		// special behaviour for slider links
		if (el.hasClass('c-slider__link') && el.find('> a').length === 1) {
			el = el.find('> a');
		}

		if(title && queue && sponsor && year) {
			title = title.trim()
			queue = queue.trim()
			sponsor = sponsor.trim()
			year = Number.isInteger(year) ? year.toString() : year;

			if (title.length > 0 && queue.length > 0 && sponsor.length > 0 && year.length > 0) {
				let hasLink = this.hasLink(el);
				if (hasLink) {
					event.preventDefault();
				}
				this.track(title, queue, sponsor, year, function () {
					if (hasLink) {
						window.location.href = el.attr('href');
					}
				});
			}
		}
	}

	hasLink(el) {
		let href = el.attr('href');
		let target = el.attr('target');

		return href !== null && href !== undefined && href[0] !== '#' && target !== '_blank';
	}

	track(title, queue, sponsor, year, callback) {
		let xhr = new XMLHttpRequest();
		xhr.open("POST", '/api/track/', true);
		xhr.onreadystatechange = function() {
			if (this.readyState == 4 && this.status == 200) {
				callback();
			}
		};
		xhr.setRequestHeader("Content-Type", "application/json");
		xhr.send(JSON.stringify({
			title: title,
			queue: queue,
			sponsor: sponsor,
			year: year
		}));
	}
}
